import React from 'react';

import { Link } from 'react-router-dom';

// images
import logo from '../../assets/images/woowii-logo.svg';
import background_image_1 from '../../assets/images/patterns/pattern-1.jpg';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-wrapper pt-0">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 offset-lg-0 col-md-8 offset-md-2 col-10 offset-1">
                            <div className="footer-row">
                                <div className="footer-detail">
                                    <Link to="#">
                                        <img src={logo} alt="footer-logo" />
                                    </Link>
                                    <p className="c-grey-1">El lugar donde los recursos humanos,  empresas y talento se unen utilizando herramientas integrales para un matching transparente de eficacia garantizada.</p>
                                    <div className="links">
                                        <a className="link-underline" href="mailto:hello@orions.com">
                                            <span>hola@woowiihr.com</span>
                                        </a>
                                        {/* <a className="link-underline" href="tel:+1-234-567-890">
                                            <span>+1 234 567 890</span>
                                        </a> */}
                                    </div>
                                </div>
                                <div className="footer-list footer-social social-gradient">
                                    <h4 class="text-color-woowii-sonic">Follow</h4>
                                    <ul>
                                        <li className="linkedin">
                                            <a href="https://www.linkedin.com/company/woowii/" target='_blank' className="link-underline">
                                                <i className="fab fa-linkedin-in"></i>
                                                <span>Linkedin</span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <div className="footer-list">
                                    <h4 class="text-color-woowii-sonic">Recursos</h4>
                                    <ul>
                                        <li>
                                            <Link to="/" className="link-underline">
                                                <span>Career Hub</span>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/"  className="link-underline">
                                                <span>Nuestra Comunidad</span>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/" className="link-underline">
                                                <span>HR Revolution Hub</span>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/" className="link-underline">
                                                <span>LinkedIn live</span>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/" className="link-underline">
                                                <span>AI Journaling</span>
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                                <div className="footer-list">
                                    <h4 class="text-color-woowii-sonic">Nosotros</h4>
                                    <ul>
                                        <li>
                                            <Link to="/request-demo" className="link-underline">
                                                <span>Pricing</span>
                                            </Link>
                                        </li>
                                        <li>
                                        <a class="link-underline" href="/#faq-section-id"><span>FQA</span></a>
                                            {/* <Link to="/" className="link-underline">
                                                <span>FQA</span>
                                            </Link> */}
                                        </li>
                                        <li>
                                            <Link to="/" className="link-underline">
                                                <span>Newsletter</span>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/" className="link-underline">
                                                <span>Trabaja con nosotros</span>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/contact" className="link-underline">
                                                <span>Contacto</span>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/privacy-policy" className="link-underline">
                                                <span>Terms of Services</span>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/privacy-policy" className="link-underline">
                                                <span>Privacy Policy</span>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/privacy-policy" className="link-underline">
                                                <span>Política de Cookies </span>
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12 offset-lg-0 col-md-8 offset-md-2 col-10 offset-1">
                            <div className="footer-copyright c-grey-1">
                                <h6> WOOWII&copy;2025 all rights reserved</h6>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer-pattern" style={{backgroundImage: `url(${background_image_1})`}}></div>
            </div>
        </footer>
    );
};

export default Footer;
